import { Theme, css, keyframes } from '@emotion/react';

export const Spinner: React.FC<{ className?: string }> = ({ className }) => {
  return <div css={styles.spinner} className={className} />;
};

const rotateAnimation = keyframes`
    from {
      transform: rotate(0deg);
    }

    to {
      transform: rotate(360deg);
    }
  `;

const styles = {
  spinner: (theme: Theme) =>
    css({
      width: '40px',
      height: '40px',
      border: `4px solid ${theme.neutral91}`,
      borderTopColor: theme.black,
      borderRadius: '50%',
      animation: `${rotateAnimation} 1s linear infinite`,
    }),
};
